module.exports = __webpack_public_path__ + "img/renewal.7b1f4b84.png";